const BuildingsListHook = {
  mounted() {
    this.focusedItem = null;

    this.el.addEventListener('focus-building', (e) => {
      this.focusedItem = e.detail;
      this.setFocus(this.focusedItem);
    });
  },

  updated() {
    // Check for open item
    let $openItem = $(this.el).find('[data-open=true]');

    if ($openItem.length > 0) {
      this.focusedItem = {
        id: $openItem.data('building-id'),
        scroll: $openItem.data('is-listing') == 'true',
      };
    }

    if (this.focusedItem) {
      this.setFocus(this.focusedItem);
    }
  },

  setFocus(item) {
    let $el = $(this.el);
    let $buildingEl = $(`#building-${item.id}`);

    if ($buildingEl.length == 0) {
      this.focusedItem = null;
      return;
    }

    // Add focus border
    if (window.innerWidth > 1024) {
      $el.find('.ring[data-card]').removeClass('ring');
      $buildingEl.find('[data-card]').addClass('ring');
    }

    if (window.innerWidth >= 1024) {
      if (item.scroll) {
        $buildingEl[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    } else {
      $buildingEl[0].scrollIntoView({
        inline: 'center',
      });
    }
  },
};

export default BuildingsListHook;
